import { useState } from 'react'
import { useRestMutation } from '@shared/hooks/rest/mutate'
import { useEasyProvider } from '@shared/components/EasyProvider'
import { useMethods } from '@shared/hooks/methods'
import { useDialogs } from '@shared/hooks/dialogs'
import { useQueryClient } from '@tanstack/react-query'

import axios from '@shared/utils/axios'
import axiosInstance from '@shared/utils/axios'

export const useList = () => {
    const [anchor, setAnchor] = useState(null)
    const [exportOpen, setExportOpen] = useState(false)

    // crud
    const queryClient = useQueryClient()
    const {
        filterQuery,
        instance,
        setInstance,
    } = useEasyProvider()
    const {
        ask,
        showMessage
    } = useMethods()
    const { mutate } = useRestMutation({
        invalidate: [['estimations']],
        process: async () => (await axios.delete(`estimations/${instance.id}/`)).data,
    })
    const { show } = useDialogs()

    // methods
    const handleDelete = () => {
        setAnchor(null)
        ask(
            `هل تريد حذف المقايسة '${instance.number}'`,
            mutate
        )
    }

    const handleFetchInstance = async () => {
        setAnchor(false)
        showMessage({
            text: 'جارٍ التحميل...',
            loading: true
        })
        try {
            const request = await axios.get(`estimations/${instance.id}/`)
            showMessage(null)
            show('estimation', request.data)
        } catch {
            showMessage({ text: 'حدث خطأ' })
        }
    }
    
    const handlePin = async () => {
        setAnchor(false)
        showMessage({
            text: 'جارٍ التثبيت...',
            loading: true
        })
        try {
            await axiosInstance.post(`estimations/${instance.id}/pin/`)
            showMessage({ text: 'تم التثبيت' })
            queryClient.invalidateQueries({ queryKey: ['estimations'] })
        } catch {
            showMessage({ text: 'حدث خطأ' })
        }
    }

    return {
        filterQuery,
        instance,
        setInstance,
        anchor,
        setAnchor,

        handleDelete,
        handleFetchInstance,
        handlePin,

        exportOpen,
        setExportOpen
    }
}
